import React from "react"
import { FormattedMessage } from "react-intl"
import Box from "../../lib/ui/ui-box"
import Text from "../text"
import Step from "../step-block"
import data from "./data"

export default () => {
  return (
    <Box style={{ position: "relative" }} flexDirection="column" px={[1, 1, 8]}>
      <Box
        align="center"
        justify="center"
        style={{ position: "relative" }}
        pb={[9]}
      >
        <Box
          w={["85%", "90%", "80%", "990px"]}
          flexDirection={["column", "column", "column"]}
          py={[2, 2, 5]}
        >
          <Box pt={[1, 4, 4, 4]}>
            <Box w={["100%", "100%", "100%"]} flexDirection="column" mb={[4]}>
              <Text
                w={1}
                color="#535353"
                fontSize={[2, 3, 4]}
                fontWeight="700"
                fontFamily="Libre Baskerville"
                lineHeight={[3, 4, 5]}
              >
                <FormattedMessage
                  id="howitworks.title"
                  defaults="How do I access the money?"
                />
              </Text>
            </Box>
          </Box>

          <Box
            flexDirection={["column"]}
            justify="center"
            align="center"
            w={["100%"]}
          >
            {data.map(step => <Step key={step.number} {...step} />)}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}



// WEBPACK FOOTER //
// ./src/components/how-it-works/how-it-works.component.js